import { ExchangeFixedType } from './common.enum';
import { CurrencyExchangeTransactionType } from './common.type';

export type ExchangeQuotePayload = {
  buyAccountId: string;
  sellAccountId: string;
  amount: string;
  fixedType: ExchangeFixedType;
  // For multi-currency wallets where buyAccountId === sellAccountId,
  // these fields identify which currency is being bought and sold.
  buyCurrency?: string;
  sellCurrency?: string;
};

export interface ExchangeQuoteSummary {
  buyCurrency: string;
  buyAmount: number;
  sellCurrency: string;
  sellAmount: number;
  feeAmount: number;
  feeCurrency: string;
  fixedSide: 'buy' | 'sell';
}

export interface ExchangeQuoteResponse extends ExchangeQuoteSummary {
  quoteId: string;
  exchangeRate: number;
  exchangeDate: string;
  expiryDateTime: string;
  cutOffTimeInMinutes: number;
  settlementDate: string;
  debitAmount: number;
  creditAmount: number;
  rateCreatedDate?: string;
  fixedSide: 'buy' | 'sell';
}

export type ExchangeTransactionResponse = {
  id: string;
  quoteId: string;
  transactionNumber: string;
  serviceProviderBuyAmount: number;
  serviceProviderSellAmount: number;
  serviceProviderRate: number;
  exchangeRate: number;
  buyCurrency: string;
  buyAmount: number;
  buyAccountId: string;
  sellCurrency: string;
  sellAmount: number;
  sellAccountId: string;
  feeAmount: number | null;
  feeCurrency: string | null;
  exchangeDate: string;
  settlementDate: string;
  debitAmount: number;
  creditAmount: number;
  status: string;
  originalExchangeDate: string;
  cancellationFee: number | null;
  fixedSide: string;
  sender?: {
    name?: string;
    accountNumber?: string;
    sortCode?: string;
    iban?: string;
    bic?: string;
    aba?: string;
    bsbCode?: string;
    ifsc?: string;
    rtnCanada?: string;
    clabe?: string;
    bankCode?: string;
    branchCode?: string;
  };
  receiver?: {
    name?: string;
    accountNumber?: string;
    sortCode?: string;
    iban?: string;
    bic?: string;
    aba?: string;
    bsbCode?: string;
    ifsc?: string;
    rtnCanada?: string;
    clabe?: string;
    bankCode?: string;
    branchCode?: string;
  };
};

export type ExchangeCurrencyTransactionsResponse = {
  id: string;
  quoteId: string;
  description: string;
  transactionNumber: string;
  rate: number;
  buyAccountId: string;
  sellAccountId: string;
  transactionDate: string;
  status: string;
  transactionType: string;
  currency: string;
  amount: number;
  buyCurrency?: string;
  sellCurrency?: string;
  buyAmount?: number;
  sellAmount?: number;
};

export const ExchangeTrxTypeFilterOptions = [
  { name: 'All', value: CurrencyExchangeTransactionType.CURRENCYALL, isActive: false },
  { name: 'Incoming', value: CurrencyExchangeTransactionType.CURRENCYINCOMING, isActive: false },
  { name: 'Outgoing', value: CurrencyExchangeTransactionType.CURRENCYOUTGOING, isActive: false },
];
